
import Bronze from "../../Assets/homepage_icons/bronze.svg";
import Silver from "../../Assets/homepage_icons/silver.svg";
import Gold from "../../Assets/homepage_icons/gold.svg";
import Basic from "../../Assets/homepage_icons/basic.svg";
import EnterPrice from "../../Assets/homepage_icons/enterprice.svg";

export const EndToEndHiring = [
    {
        name: "Basic",
        img: Basic,
        desc: "1 job post ",
        basePrice: '₹15,001',
        price: "₹9,999",
        // paymentLink: 'https://rzp.io/rzp/5fSMP4ah',
        planName: 'Basic',
        mrp: 9999, // useable as a nuber to calculations
    },
    {
        name: "Silver",
        img: Silver,
        desc: "10 job post ",
        basePrice: '₹142,501',
        price: "₹94,990",
        isRecommended: true, // Marking as recommended
        // paymentLink: 'https://rzp.io/rzp/PUyPjYpM',
        planName: 'Silver',
        mrp: 94990,
    },
    {
        name: "Gold",
        img: Gold,
        desc: "50 job post ",
        basePrice: '₹675,001',
        price: "₹4,49,950",
        // paymentLink: 'https://rzp.io/rzp/hr3k5G3',
        planName: 'Gold',
        mrp: 449950,
    },
    {
        name: "Enterprise",
        img: EnterPrice,
        desc: "Custom",
        price: "Contact Us",
        isEnterprise: true,
        planName: 'Enterprise',
    }
];

export const SmartHiring = [
    {
        name: "Basic",
        // basePrice: '₹150,001',
        img: Bronze,
        desc: "10 video interview",
        basePrice: '',
        price: "₹15,001",
        // paymentLink: 'https://rzp.io/rzp/5fSMP4ah',
        planName: 'Basic',
        mrp: 15001,
    },
    {
        name: "Micro sized Recruiters",
        img: Silver,
        desc: "100 video interviews",
        price: "₹84,700",
        basePrice: '₹350,000',
        isRecommended: true, // Marking as recommended
        // paymentLink: 'https://rzp.io/rzp/PUyPjYpM',
        planName: 'Micro',
        mrp: 84700,
    },
    {
        name: "Small to Medium sized Recruiters",
        img: Gold,
        desc: "500 video interviews",
        price: "₹423,500",
        basePrice: '₹1,750,000',
        planName: 'Small',
        // paymentLink: 'https://rzp.io/rzp/hr3k5G3',
        mrp: 423500,
    },
    {
        name: "Medium sized Recruiters",
        img: EnterPrice,
        desc: "1000 video interviews",
        price: "₹847,000",
        basePrice: "₹3,000,000",
        planName: 'Medium',
        // isEnterprise: true
        mrp: 847000,
    },

    {
        isEnterprise: true,
        desc: "Monthly / Yearly Platform fee (co-branded) ",
        img: "",
        name: "White labelling",
        price: "Contact Us",
        planName: 'WhiteLabellingMonthly',
    },
];
export const mockPlans = [
    {
        name:"Basic",
        desc: '1 Mock AI Interview',
        basePrice: '₹99',
        price: '₹39',
        offerPrice: '39',
        planName: 'BASIC',
        mrp: 39,
        img: Basic,
        paymentRoute: `/purchase?plan_name=BASIC&plan_type=MOCK`,
    },
    {
        name: "Copper",
        desc: '3 Mock AI Interview',
        basePrice: '₹297',
        price: '₹87',
        offerPrice: '87',
        planName: 'COPPER',
        mrp: 87,
        img: Bronze,
        paymentRoute: `/purchase?plan_name=COPPER&plan_type=MOCK`,
        // isRecommended: true, // Marking as recommended
    },
    {
        name: "Silver",
        desc: '5 Mock AI Interview',
        basePrice: '₹495',
        price: '₹95',
        offerPrice: '95',
        planName: 'SILVER',
        mrp: 95,
        img: Silver,
        paymentRoute: `/purchase?plan_name=SILVER&plan_type=MOCK`,
    },
];